import { useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { publicationdetail } from "../../../../services/publicationService";
import { buildPDFPath } from "../../../../utils/slugify";
import { AppContext } from "../../../../services/AuthContext";

export default function RedirectPDFProtectedAccessById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await publicationdetail(id, auth?.token);
        if (!alive) return;

        if (res?.status === "OK") {
          const pub = res.data?.elasticjson || res.data;

          // Başlık tespiti
          let title =
            pub?.publicationtypeInfo?.find(
              (a) => a.attributename?.toLowerCase() === "başlık"
            )?.value?.[0]?.value?.[0] ||
            pub?.parentList?.[0]?.publicationtypeInfo?.find(
              (a) => a.attributename?.toLowerCase() === "başlık"
            )?.value?.[0]?.value?.[0] ||
            pub?.title ||
            `Yayın-${id}`;

          // buildPDFPath fonksiyonuna bir 'type' parametresi ekleyerek 
          // protected path üretmesini sağlayabilirsiniz veya manuel oluşturun:
          const slug = buildPDFPath({ title, id });
          // Eğer buildPDFPath sadece '/view/pdf/...' üretiyorsa, replace ile değiştirin:
          const protectedSlug = slug.replace("/view/pdf/", "/view/pdf-protected/");

          navigate(protectedSlug, { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } catch (e) {
        navigate("/home", { replace: true });
      }
    })();
    return () => { alive = false; };
  }, [id, navigate, auth]);

  return null;
}